export default "<app-holidays-list></app-holidays-list>";